/* eslint-disable jira/naming/disallow-filenames */
// eslint-disable-next-line jira/filename-case
import React, { useCallback, useMemo } from 'react';
import { useNotifications as useNotificationsLibrary } from '@jira/polaris__lib-notifications/src/useNotifications.tsx';
import InformationIcon from '@atlaskit/icon/core/status-information';
import { token } from '@atlaskit/tokens';

type InfoNotification = {
	title: string;
	description: string;
};

type ErrorNotification = {
	title: string;
	description: string;
	actionLabel: string;
	actionTestId: string;
	onActionClick: () => void;
};

export const useNotifications = (): {
	error: ({
		title,
		description,
		actionLabel,
		actionTestId,
		onActionClick,
	}: ErrorNotification) => void;
	info: ({ title, description }: InfoNotification) => void;
} => {
	const { error: errorFlag, customFlag } = useNotificationsLibrary();

	const error = useCallback(
		({ title, description, actionLabel, actionTestId, onActionClick }: ErrorNotification) => {
			const dismissErrorFlag = errorFlag({
				title,
				description,
				actions: [
					{
						content: actionLabel,
						testId: actionTestId,
						onClick: () => {
							onActionClick();
							dismissErrorFlag();
						},
					},
				],
			});
		},
		[errorFlag],
	);

	const info = useCallback(
		({ title, description }: InfoNotification) => {
			customFlag({
				title,
				description,
				icon: (
					<InformationIcon spacing="spacious" label="" color={token('color.icon.information')} />
				),
			});
		},
		[customFlag],
	);

	return useMemo(
		() => ({
			error,
			info,
		}),
		[error, info],
	);
};
